import { render, staticRenderFns } from "./DocTemplates.vue?vue&type=template&id=731dddbd&"
import script from "./DocTemplates.vue?vue&type=script&lang=ts&"
export * from "./DocTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports